import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { GetPublicAdvisorAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'


export const ratingBreakdownReducer: Reducer<AdvisorDataState['ratingBreakdown']> = (prevState = {}, action) => {
  switch (action.type) {
    case GetPublicAdvisorAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { uid, rating_breakdown } = action.payload.response

      return {
        ...prevState,
        [uid]: rating_breakdown,
      }
    }
  }
  return prevState
}
